import { RouteRecordRaw } from 'vue-router'

const ruzuxingwei: Array<RouteRecordRaw> = [{
    path: '/ruzuxingwei',
    meta: {
        title: "战队用户数据明细"
    },
    component: () => import("@/views/ruzuxingwei/list.vue")
}];
export default ruzuxingwei;